define([
        "dojo/_base/lang",
        "../../../constants/TypeConstants",
        "../properties/TypeProperty",
        "../properties/TagProperty",
        "../properties/TextProperty",
        "../properties/TextOverrideProperty",
        "../properties/IconProperty",
        "../properties/IconOverrideProperty",
        "../properties/EnabledProperty",
        "../properties/DescriptionProperty",
        "../properties/DescriptionOverrideProperty",
        "../properties/MnemonicProperty",
        "../properties/ShortcutProperty",
        "../properties/ActionIdProperty",
        "../properties/ShowDescriptionProperty",
        "../properties/HasDynamicPopupProperty",
        "../properties/QuickAccessIconProperty",
        "../properties/UseQuickAccessIconProperty",
        "../properties/IsInQABProperty"

    ],
    function (lang, TypeConstants, TypeProperty, TagProperty, TextProperty, TextOverrideProperty, IconProperty,
              IconOverrideProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty,
              ShortcutProperty, ActionIdProperty, ShowDescriptionProperty, HasDynamicPopupProperty, QuickAccessIconProperty,
              UseQuickAccessIconProperty, IsInQABProperty) {
        var hash = {};

        hash[TypeConstants.LIST_ITEM_WITH_POPUP] = lang.mixin({}, {
                popupId: {
                    type: "string",
                    defaultValue: "",
                    notInAction: false,
                    required: false
                },
                showIcon: {
                    type: "boolean",
                    defaultValue: true,
                    notInAction: true,
                    required: false,
                    description: "Using this you can toggle the visibility of the icon on the list item."
                },
                showText: {
                    type: "boolean",
                    defaultValue: true,
                    notInAction: true,
                    required: false
                }
            }, TypeProperty, TagProperty, TextProperty, TextOverrideProperty, IconProperty, IconOverrideProperty,
            EnabledProperty, DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty,
            ActionIdProperty, ShowDescriptionProperty, HasDynamicPopupProperty, QuickAccessIconProperty,
            UseQuickAccessIconProperty, IsInQABProperty);

        return hash;
    });

